import { NavigationGuard } from "vue-router";
import userManager from "@/plumbing/auth";
import { removeLoadingScreen } from "@/plumbing/loadingScreen";
const ensureUserIsLoggedIn: NavigationGuard = async (to, from, next) => {
  if (to.name === "SignInCallback" || to.meta.isPublic) {
    next();
    return;
  }

  const user = await userManager.getUser();

  if (user === null || user.expired) {
    try {
      await userManager.signinRedirect();
    } catch (error) {
      console.error(error);
      next({ name: "Error" });
      removeLoadingScreen();
    }
  } else {
    next();
    removeLoadingScreen();
  }
};

export default ensureUserIsLoggedIn;
